"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../types");
/**
 * TO BE DEPRECATED
 */
const getColor = ({ theme, type }) => type === types_1.toastTypes.error || type === types_1.toastTypes.warning
    ? theme.colorError
    : theme.color;
exports.default = getColor;
